import { SopStep } from "../Models/SopStep";
import { StepCard } from "../Models/StepCard";
export function stepCards() {
  return {
    stepCardId: ObjectId(3),
    indications: {},
    stepTittle: "",
    stepImage: null,
    hygieneRelevantStep: "",
    comments: ""
  } as StepCard
}

export function sop() {
  return {
    stepId: ObjectId(3),
    stepType: false,
    stepName: "",
    stepCards: [stepCards()]
  } as SopStep
}

export function ObjectId(length) {
  var chars = "0123456789";
  var number = "";
  for (var x = 0; x < length; x++) {
    var i = Math.floor(Math.random() * chars.length);
    number += chars.charAt(i);
  }
  return parseInt(number);
}
